export default {
  en: {
    minutes_one: '{{count}} minute',
    minutes_other: '{{count}} minutes',
    minutesPerDay_one: '{{count}} minute a day',
    minutesPerDay_other: '{{count}} minutes a day',
    dailyGoal: 'Daily goal',
    title: 'Personalization',
    loadError: 'Failed to load',
    enable: 'Personalization',
    enableHint:
      'Personalization is used to make conversations more interesting.',
    goals: 'Goals',
    interests: 'Interests',
    knowledgeBase: 'Knowledge base',
  },
  ru: {
    minutes_one: '{{count}} минута',
    minutes_few: '{{count}} минуты',
    minutes_many: '{{count}} минут',
    minutes_other: '{{count}} минуты',
    minutesPerDay_one: '{{count}} минута в день',
    minutesPerDay_few: '{{count}} минуты в день',
    minutesPerDay_many: '{{count}} минут в день',
    minutesPerDay_other: '{{count}} минуты в день',
    dailyGoal: 'Цель на день',
    title: 'Персонализация',
    loadError: 'Не удалось загрузить',
    enable: 'Персонализация',
    enableHint:
      'Персонализация используется для того, чтобы диалоги были интереснее.',
    goals: 'Цели',
    interests: 'Интересы',
    knowledgeBase: 'База знаний',
  },
  de: {
    minutes_one: '{{count}} Minute',
    minutes_other: '{{count}} Minuten',
    minutesPerDay_one: '{{count}} Minute pro Tag',
    minutesPerDay_other: '{{count}} Minuten pro Tag',
    dailyGoal: 'Tagesziel',
    title: 'Personalisierung',
    loadError: 'Laden fehlgeschlagen',
    enable: 'Personalisierung',
    enableHint:
      'Die Personalisierung sorgt dafür, dass die Dialoge interessanter werden.',
    goals: 'Ziele',
    interests: 'Interessen',
    knowledgeBase: 'Wissensbasis',
  },
  pt: {
    minutes_one: '{{count}} minuto',
    minutes_other: '{{count}} minutos',
    minutesPerDay_one: '{{count}} minuto por dia',
    minutesPerDay_other: '{{count}} minutos por dia',
    dailyGoal: 'Meta diária',
    title: 'Personalização',
    loadError: 'Falha ao carregar',
    enable: 'Personalização',
    enableHint:
      'A personalização serve para deixar os diálogos mais interessantes.',
    goals: 'Objetivos',
    interests: 'Interesses',
    knowledgeBase: 'Base de conhecimento',
  },
  fr: {
    minutes_one: '{{count}} minute',
    minutes_other: '{{count}} minutes',
    minutesPerDay_one: '{{count}} minute par jour',
    minutesPerDay_other: '{{count}} minutes par jour',
    dailyGoal: 'Objectif du jour',
    title: 'Personnalisation',
    loadError: 'Échec du chargement',
    enable: 'Personnalisation',
    enableHint:
      'La personnalisation sert à rendre les dialogues plus intéressants.',
    goals: 'Objectifs',
    interests: 'Centres d’intérêt',
    knowledgeBase: 'Base de connaissances',
  },
  es: {
    minutes_one: '{{count}} minuto',
    minutes_other: '{{count}} minutos',
    minutesPerDay_one: '{{count}} minuto al día',
    minutesPerDay_other: '{{count}} minutos al día',
    dailyGoal: 'Meta diaria',
    title: 'Personalización',
    loadError: 'No se pudo cargar',
    enable: 'Personalización',
    enableHint:
      'La personalización sirve para que los diálogos sean más interesantes.',
    goals: 'Objetivos',
    interests: 'Intereses',
    knowledgeBase: 'Base de conocimientos',
  },
};
